module.exports = __webpack_public_path__ + "img/require-icon-3.931b313b.png";